import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

export const dashboardService = {
  summary: () => apiClient.get('/admin/dashboard/summary'),
  charts: (params) => apiClient.get('/admin/dashboard/charts', { params: cleanParams(params) }),
  distributions: (params) =>
    apiClient.get('/admin/dashboard/distributions', { params: cleanParams(params) }),
  recent: (params) => apiClient.get('/admin/dashboard/recent', { params: cleanParams(params) }),
};

export default dashboardService;
